import React from 'react';
import './twitter.css';

function Twitter() {
  return (
      <>
        <div className='twitter_main'>
          <p className='love_wall'>Wall of <br/> L❤️VE</p>
        </div>
        <div className='tweets'>
          <p className='tweet_posts'>Embedded Twitter Post</p>
        </div>
      </>
  );
}

export default Twitter;
